const styles = {
    global: {
        '*': {
            WebkitTapHighlightColor: 'transparent',
            '::-webkit-scrollbar': { width: '10px', backgroundColor: '#f4f4f4' },

            '::-webkit-scrollbar-track': {
                backgroundColor: '#f4f4f4',
            },

            '::-webkit-scrollbar-thumb': {
                backgroundColor: '#888',
                borderRadius: '4px',
            },

            '::-webkit-scrollbar-thumb:hover': {
                backgroundColor: '#555',
                cursor: 'pointer',
            },
        },
    },
};

export default styles;
